module.exports = __webpack_public_path__ + "img/hemp-oil-care.ad0931ae.jpg";